











































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { Toast } from 'vant';
@Component({
  components: {},
})
export default class TrainDetail extends Vue {
  @Prop(Boolean) show: boolean;
  @Prop(Object) trainScheduling: any;
  showTrainDetail: boolean = false;
  currTrainScheduling: any;
  @Watch('show')
  showTrainDetailChange(v: boolean) {
    if (v) {
      this.showTrainDetail = v;
      this.currTrainScheduling = this.trainScheduling;
      if (this.currTrainScheduling) {
        let obj = this.currTrainScheduling;
        //课程形式转成文字
        switch (obj.courseForm) {
          case 0:
            this.$set(obj, 'courseForm', '分组研讨');
            break;
          case 1:
            this.$set(obj, 'courseForm', '网络培训');
            break;
          case 2:
            this.$set(obj, 'courseForm', '网络培训');
            break;
          case 3:
            this.$set(obj, 'courseForm', '网络培训');
            break;
          case 4:
            this.$set(obj, 'courseForm', '网络培训');
            break;
        }
      }
    }
  }
  onConfirm() {
    this.$emit('updateTrainDetailShow');
  }
}
